import { render, staticRenderFns } from "./BillOfLading.vue?vue&type=template&id=5b13ca9d&scoped=true"
import script from "./BillOfLading.vue?vue&type=script&lang=ts"
export * from "./BillOfLading.vue?vue&type=script&lang=ts"
import style0 from "./BillOfLading.vue?vue&type=style&index=0&id=5b13ca9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../nhaphangtocdo/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b13ca9d",
  null
  
)

export default component.exports